import { get, patch, post, put } from "@/infra/rest";
import {
  AddCollaboratorsToAgentSessionRequest,
  AgentSessionCreateRequest,
  AgentSessionCreateResponse,
  AgentSessionResponse,
  AgentSessionStepUpdateRequest,
  AgentSessionStepUpdateResponse,
  AgentSessionType,
  AgentSessionsRequest,
  AgentSessionsResponse,
  CustomGapAssessmentRagCreateRequest,
  DoraRagCreateRequest,
  FairRagCreateRequest,
  MultiFileVendorRagCreateRequest,
  NistAIRMFRagCreateRequest,
  NistCsf2RagCreateRequest,
  QARagCreateRequest,
  Soc2RagCreateRequest,
} from "../types";
import { getZaniaSocket } from "@/infra/sockets";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/shared/constants/QueryKeys";


export const getPaginatedAgentSessions = async (
  data: AgentSessionsRequest,
): Promise<AgentSessionsResponse> => {
  const { signal, ...requestData } = data;
  const response = await post<Omit<AgentSessionsRequest, 'signal'>, AgentSessionsResponse>({
    url: "/v0/agents/sessions",
    data: requestData,
    useCookies: true,
    config: { signal }
  });
  // // Manual update data for testing CUstom Agents 
  // const reqIndex = response.data.sessions.findIndex(x => x.session.id === "5b124b6a5d4211f0867112576af1c9c0");
  // let reqSessionDetails  =  response.data.sessions.find(x => x.session.id === "5b124b6a5d4211f0867112576af1c9c0");
  // reqSessionDetails={...reqSessionDetails, 
  //   session: {
  //     ...reqSessionDetails.session, 
  //     type: AgentSessionType.GAP_CUSTOM_FRAMEWORK,
  //     gap_custom_framework: reqSessionDetails.session.soc2_type1,
  //     soc2_type1: null
  //   }
  // }
  // response.data.sessions[reqIndex] = reqSessionDetails
  
  return {data : response} as any;
};

export const getAgentSession = async (
  sessionId: string,
): Promise<AgentSessionResponse> => {
  const response = await get<AgentSessionResponse>({
    url: `/v0/agents/session/${sessionId}`,
  });
  return response;
};


export const createAgentSession = async (data: AgentSessionCreateRequest) => {
  const response = await post<
    AgentSessionCreateRequest,
    AgentSessionCreateResponse
  >({
    url: "/v0/agents/session",
    data,
  });
  return response;
};

export const updateAgentSessionStep = async (
  data: AgentSessionStepUpdateRequest,
) => {
  data.updated_at = new Date().toISOString();
  const response = await put<
    AgentSessionStepUpdateRequest,
    AgentSessionStepUpdateResponse
  >({
    url: `/v0/agents/step/${data.id}`,
    data,
  });
  return response;
};

export const addCollaboratorsToAgentSession = async (
  sessionId: string,
  collaboratorIds: string[],
): Promise<AddCollaboratorsToAgentSessionRequest> => {
  const response = await patch<AddCollaboratorsToAgentSessionRequest>({
    url: `/v0/agents/session/${sessionId}`,
    config: {
      data: {
        all: false,
        collaborators: collaboratorIds,
      },
    },
  });

  return response;
};


export const getAgentSessionControls = async (
  sessionId: string,
): Promise<any> => {
  const response = await get<any>({
    url: `/v0/agents/session/${sessionId}/controls`,
  });
  return response;
};


export const ragCreateAPI = async (
  data:
    | FairRagCreateRequest
    | Soc2RagCreateRequest
    | NistCsf2RagCreateRequest
    | NistAIRMFRagCreateRequest
    | DoraRagCreateRequest
    | MultiFileVendorRagCreateRequest 
    | QARagCreateRequest
    | CustomGapAssessmentRagCreateRequest,
  callback?: (...args: any[]) => void,
) => {
  const socket = getZaniaSocket();
  data.socket_id = socket.id
  try {
    const response = await post<typeof data, any>({
      url: '/v0/rag/create-task',
      data,
    });
    if (callback) {
      callback(response);
    }
  } catch (error) {
    if (callback) {
      callback(null, error);
    }
  }
};
